"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Alert = void 0;
/**
 * Copyright © 2019 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
const react_1 = __importDefault(require("react"));
const material_1 = require("@mui/material");
exports.Alert = (props) => {
    const { children, open } = props, restProps = __rest(props, ["children", "open"]);
    return (react_1.default.createElement(material_1.Collapse, { in: open },
        react_1.default.createElement(material_1.Alert, Object.assign({}, restProps, { variant: "standard" }), children)));
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQWxlcnQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvY29tcG9uZW50cy9hbGVydHMvQWxlcnQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUE7Ozs7OztHQU1HO0FBQ0gsa0RBQTBCO0FBQzFCLDRDQUE0RDtBQU8vQyxRQUFBLEtBQUssR0FBRyxDQUFDLEtBQWtCLEVBQUUsRUFBRTtJQUMxQyxNQUFNLEVBQUUsUUFBUSxFQUFFLElBQUksS0FBbUIsS0FBSyxFQUFuQixTQUFTLFVBQUssS0FBSyxFQUF4QyxvQkFBZ0MsQ0FBUSxDQUFDO0lBRS9DLE9BQU8sQ0FDTCw4QkFBQyxtQkFBUSxJQUFDLEVBQUUsRUFBRSxJQUFJO1FBQ2hCLDhCQUFDLGdCQUFRLG9CQUFLLFNBQVMsSUFBRSxPQUFPLEVBQUMsVUFBVSxLQUN4QyxRQUFRLENBQ0EsQ0FDRixDQUNaLENBQUM7QUFDSixDQUFDLENBQUMifQ==